import { GlobeAltIcon } from "@heroicons/react/24/outline";

import ConfirmModal from "../shared/Confirm/ConfirmModal";
import { IPartRequest } from "../../models/partRequests/IPartRequest";
import { partRequestVehicleLabel } from "../../utils/partRequests";

interface PublishToNetworkConfirmProps {
  open: boolean;
  setOpen: any;
  request: IPartRequest | undefined;
  onConfirm: () => void;
  isLoading: boolean;
}

export default function PublishToNetworkConfirm({ open, setOpen, request, onConfirm, isLoading }: PublishToNetworkConfirmProps) {
  const vehicle = request ? partRequestVehicleLabel(request) : "";
  const message =
    `This request will be shared with the other yards on the PartPro network.\n\n` +
    `They will see the vehicle and the part only: "${request?.partWanted ?? ""}" for a ${vehicle}. ` +
    `Your customer's name and contact details stay in Wilma - the other yards never see them.\n\n` +
    `A yard that has the part offers it back to you and can message you here in Wilma. ` +
    `You buy it from them and sell it on to your customer. ` +
    `You can withdraw the request from the network at any time.`;

  return (
    <ConfirmModal
      open={open}
      setOpen={setOpen}
      title="Fulfil on the PartPro network?"
      message={message}
      confirmButtonText="Send to network"
      onConfirm={onConfirm}
      isLoading={isLoading}
      Icon={<GlobeAltIcon className="h-6 w-6 text-primary-600" aria-hidden="true" />}
      iconBg="bg-primary-100"
    />
  );
}
